import { render, staticRenderFns } from "./ModalNoticeTemplate.vue?vue&type=template&id=cedcb104&scoped=true"
import script from "./ModalNoticeTemplate.vue?vue&type=script&lang=js"
export * from "./ModalNoticeTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalNoticeTemplate.vue?vue&type=style&index=0&id=cedcb104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedcb104",
  null
  
)

export default component.exports